import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { FatalError } from '@/components/FatalError'
import '@/index.css'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Elemento #root nao encontrado em index.html.')

const root = createRoot(rootElement)

// Import dinamico de proposito: a validacao de `env` roda no carregamento do
// modulo, antes de qualquer render. Estatico, um erro ali entrega tela branca;
// assim, entrega a mensagem que diz o que fazer.
import('@/App')
  .then(({ App }) => {
    root.render(
      <StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </StrictMode>,
    )
  })
  .catch((error: unknown) => {
    console.error(error)
    root.render(<FatalError error={error} />)
  })
